/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export interface Address {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
}
